import { motion } from 'framer-motion';

const PartnersSection = () => {
  const festivalPartners = [
    {
      name: 'EDC',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/e4ra7l9l_EDC.png',
      url: 'https://electricdaisycarnival.com',
    },
    {
      name: 'Electric Forest',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/ag0yyxgp_Electric%20Forest.png',
      url: 'https://electricforestfestival.com',
    },
    {
      name: 'Lost Lands',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/pp8cwwmb_Lost%20Lands.png',
      url: 'https://lostlandsfestival.com',
    },
    {
      name: 'Okeechobee Music & Arts Festival',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/vpnns10b_Okeechobee.png',
      url: 'https://okeechobeefest.com',
    },
    {
      name: 'Forbidden Kingdom',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/tsk6ruu1_Forbidden%20Kingdom.png',
      url: 'https://forbiddenkingdomfestival.com',
    },
    {
      name: 'Elements Music and Arts Festival',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/47832yv9_Elements.png',
      url: 'https://elementsfest.us',
    },
    {
      name: 'Project Glow',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/d11wskvd_Project%20Glow.png',
      url: 'https://projectglow.com',
    },
    {
      name: 'Grid Life',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/0meiuehb_Grid%20Life.png',
      url: 'https://grid.life',
    },
  ];

  const vendingPartners = [
    {
      name: 'Insomniac',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/hhk41t08_Insomniac.png',
      url: 'https://insomniac.com',
    },
    {
      name: 'DLS Events',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/x4z2csrg_DLS.png',
      url: 'https://dlsevents.com',
    },
    {
      name: 'Levy',
      logo: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/njm3id3s_Levy.png',
      url: 'https://levyrestaurants.com',
    },
  ];

  return (
    <section 
      id="partners" 
      data-testid="partners-section"
      className="relative py-16 md:py-24 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-[#CCFF00] text-sm font-medium tracking-widest uppercase mb-2 block">
            Trusted By Leading Festivals
          </span>
          <h3 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-tight">
            Our Festival Partners
          </h3>
        </motion.div>

        {/* Festival Logo Grid */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 items-center justify-items-center"
        >
          {festivalPartners.map((partner, index) => (
            <motion.a
              key={partner.name}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="group relative flex items-center justify-center"
              data-testid={`partner-logo-${index}`}
            >
              <div className="relative w-28 h-28 md:w-32 md:h-32 flex items-center justify-center p-3 rounded-2xl bg-white/5 border border-white/10 transition-all duration-300 group-hover:border-[#CCFF00]/30 group-hover:bg-white/10">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain filter brightness-100 group-hover:brightness-110 transition-all duration-300"
                />
              </div>
            </motion.a>
          ))}
        </motion.div>

        {/* Vending Partners */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 text-center"
        >
          <p className="text-white/50 text-xs uppercase tracking-widest mb-6">
            Corporate Partners
          </p>
          <div className="flex flex-wrap justify-center gap-6 md:gap-8">
            {vendingPartners.map((partner, index) => (
              <motion.a
                key={partner.name}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.5 + index * 0.1 }}
                className="group relative flex items-center justify-center"
                data-testid={`vending-partner-${index}`}
              >
                <div className="relative w-28 h-28 md:w-32 md:h-32 flex items-center justify-center p-3 rounded-2xl bg-white/5 border border-white/10 transition-all duration-300 group-hover:border-[#FF0099]/30 group-hover:bg-white/10">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain filter brightness-100 group-hover:brightness-110 transition-all duration-300"
                  />
                </div>
              </motion.a>
            ))}
          </div>
        </motion.div>

        {/* Bottom Text */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-center text-white/40 text-sm mt-10 uppercase tracking-widest"
        >
          And many more across the country
        </motion.p>
      </div>
    </section>
  );
};

export default PartnersSection;
